"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.endpointDeclaration = endpointDeclaration;
exports.bindDeclaration = bindDeclaration;
function endpointDeclaration(reqParser, respParser) {
    return {
        reqParser,
        respParser,
    };
}
function bindDeclaration(decl, handler) {
    if (typeof handler === 'function') {
        handler = new DelegatingHandler(handler);
    }
    return { decl, endpoint: handler };
}
class DelegatingHandler {
    handlerFunction;
    constructor(handlerFunction) {
        this.handlerFunction = handlerFunction;
    }
    handle(req, httpRequestInfo) {
        return Promise.resolve(this.handlerFunction(req, httpRequestInfo));
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW5kcG9pbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2VuZHBvaW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQStCQSxrREFRQztBQVVELDBDQVFDO0FBMUJELFNBQWdCLG1CQUFtQixDQUNqQyxTQUF3QixFQUN4QixVQUEwQjtJQUUxQixPQUFPO1FBQ0wsU0FBUztRQUNULFVBQVU7S0FDWCxDQUFBO0FBQ0gsQ0FBQztBQVVELFNBQWdCLGVBQWUsQ0FDN0IsSUFBb0MsRUFDcEMsT0FBcUM7SUFFckMsSUFBSSxPQUFPLE9BQU8sS0FBSyxVQUFVLEVBQUUsQ0FBQztRQUNsQyxPQUFPLEdBQUcsSUFBSSxpQkFBaUIsQ0FBWSxPQUFPLENBQUMsQ0FBQTtJQUNyRCxDQUFDO0lBQ0QsT0FBTyxFQUFFLElBQUksRUFBRSxRQUFRLEVBQUUsT0FBTyxFQUFFLENBQUE7QUFDcEMsQ0FBQztBQUVELE1BQU0saUJBQWlCO0lBQ1E7SUFBN0IsWUFBNkIsZUFBMkM7UUFBM0Msb0JBQWUsR0FBZixlQUFlLENBQTRCO0lBQUcsQ0FBQztJQUU1RSxNQUFNLENBQUMsR0FBUSxFQUFFLGVBQTRCO1FBQzNDLE9BQU8sT0FBTyxDQUFDLE9BQU8sQ0FBQyxJQUFJLENBQUMsZUFBZSxDQUFDLEdBQUcsRUFBRSxlQUFlLENBQUMsQ0FBQyxDQUFBO0lBQ3BFLENBQUM7Q0FDRiJ9